import React from "react"

export const icons = {
  burger: {
    viewBox: "0 0 48 48",
    customCode: (
      <>
        <line
          y1="17.5"
          x2="48"
          y2="17.5"
          stroke="currentColor"
          strokeWidth="5"
        />
        <line
          y1="31.5"
          x2="48"
          y2="31.5"
          stroke="currentColor"
          strokeWidth="5"
        />
      </>
    ),
  },
  "close-red": {
    viewBox: "0 0 96 100",
    customCode: (
      <>
        <rect width="96" height="100" fill="#FF004F" />
        <line
          x1="22.4142"
          y1="19.5858"
          x2="80.4142"
          y2="77.5858"
          stroke="black"
          strokeWidth="4"
        />
        <line
          x1="19.5858"
          y1="77.5858"
          x2="44.5858"
          y2="52.5858"
          stroke="black"
          strokeWidth="4"
        />
        <line
          x1="54.5858"
          y1="42.5858"
          x2="77.5858"
          y2="19.5858"
          stroke="black"
          strokeWidth="4"
        />
      </>
    ),
  },
  "close-black": {
    viewBox: "0 0 100 100",
    customCode: (
      <>
        <rect width="100" height="100" fill="black" />
        <line
          x1="22.4142"
          y1="19.5858"
          x2="80.4142"
          y2="77.5858"
          stroke="#FF004F"
          strokeWidth="4"
        />
        <line
          x1="19.5858"
          y1="77.5858"
          x2="44.5858"
          y2="52.5858"
          stroke="#FF004F"
          strokeWidth="4"
        />
        <line
          x1="54.5858"
          y1="42.5858"
          x2="77.5858"
          y2="19.5858"
          stroke="#FF004F"
          strokeWidth="4"
        />
      </>
    ),
  },
  "arrow-right": {
    viewBox: "0 0 100 100",
    customCode: (
      <>
        <path d="M21 21.5L49 50.5L21 79.5" stroke="black" strokeWidth="4" />
        <path d="M49 21.5L79 50.5L49 79.5" stroke="black" strokeWidth="4" />
      </>
    ),
  },
  outlink: {
    viewBox: "0 0 24 24",
    customCode: (
      <>
        <path
          d="M9.5 5.5H18.5V14.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
        <path
          d="M5.77194 18.2279L18.4998 5.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="bevel"
        />
      </>
    ),
  },
}
